import Vue from 'vue'

export default Vue.extend({
  name: 'TTransferListItem',
  props: {
    data: {
      type: Object,
      default: null,
      required: true
    }
  },
  render: function(createElement) {
    const parent = this.$parent.$parent
    const data = this.data
    return parent.renderContent ? createElement('span', {}, [
      parent.renderContent(createElement, data)
    ]) : createElement(
      'span', {
        attrs: {
          title: data.label
        }
      },
      data.label
    )
  }
})



// WEBPACK FOOTER //
// ./src/module/transfer/list-item.js